import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import axios from 'axios';

let BASE_URL = process.env.REACT_APP_BASE_URL;
const ENV_RESOURCE = process.env.REACT_APP_ENV_RESOURCE;

const OverwriteManagerModal = ({ isOpen, toggle, onConfirm, close }) => {
  const handleConfirm = async () => {
    await axios.get(`${BASE_URL}web/overwriteManager`);
    onConfirm();
  };

  const handleLogout = () => {
    // Clear local storage
    localStorage.removeItem(`accessToken_${ENV_RESOURCE}`);
    localStorage.removeItem(`refreshToken_${ENV_RESOURCE}`);
    
    // Redirect to login page
    window.location.href = "/login";
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} keyboard={false} backdrop="static">
      <ModalHeader>Warning</ModalHeader>
      <ModalBody>
        {close ? (
          <div>
            This tab is closed by another tab. Continuing from this tab will overwrite the other tab. 
            This is a destructive action that can harm measurement if there is any measurement going on in the other tab.
          </div>
        ) : (
          <div>
            There is another tab open. Continuing from this tab will overwrite the other tab. 
            This is a destructive action that can harm measurement if there is any measurement going on in the other tab.
          </div>
        )}
      </ModalBody>
      <ModalFooter className="d-flex justify-content-between">
        <Button color="secondary" onClick={handleLogout}>
          Logout
        </Button>
        <Button color="danger" onClick={handleConfirm}>
          Overwrite
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default OverwriteManagerModal;